import { htmlToCanvas } from "@assets/scripts/features";
// 用来存放公共的方法
import api from "@/assets/scripts/api";
import http from "@/plugins/http";
import store from "@/store/index";
import { saveAs } from "file-saver";

const makeMap = (str, expectsLowerCase) => {
  var map = Object.create(null);
  var list = str.split(",");
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return function (val) {
    return expectsLowerCase ? map[val.toLowerCase()] : map[val];
  };
};

const isArray = arr => Array.isArray(arr);

const isObject = obj => obj !== null && typeof obj === "object";

const toString = Object.prototype.toString;
const OBJECT_STRING = "[object Object]";

const isPlainObj = obj => toString.call(obj) === OBJECT_STRING;

const hexToRGB = hex => {
  if (typeof hex !== "string") {
    return null;
  }
  if (/rgb/.test(hex)) {
    return hex;
  }
  // 过滤非法输入
  if (!/^#[0-9ABCDEFabcdef]{1,6}$/.test(hex)) {
    return null;
  }
  let pureStr = hex.slice(1);
  // 处理简写形式
  if (pureStr.length === 3) {
    // 7f7 => [7, f, 7] => [[7], [f], [7]] => [[77], [ff], [77]] => [77, ff, 77] => 77ff77
    pureStr = [].concat(...[...pureStr].map(v => [v]).map(v => v.concat(v))).join("");
  }
  let result = [];
  for (let i = 0; i < pureStr.length; i += 2) {
    result.push(parseInt(pureStr[i] + pureStr[i + 1], 16));
  }
  return result;
};
// 批量下载 arrs:[{"name": "封面", "datas": "coverDataList"}, {"name": "海报", "datas": "bannerDataList"}, {"name": "海报", "datas": "posterDataList"}]
export const downloadBase64Pile = async arrs => {
  // 绘制
  const imgMaps = [];
  for (let i = 0; i < arrs.length; i++) {
    const item = arrs[i];
    for (let j = 0; j < item.datas.length; j++) {
      const drawData = item.datas[j];
      let dom = document.querySelector("#" + item.name + j);
      const base64Data = await htmlToCanvas(dom, 2);
      let fileName = '';

      if (item.name === "poster") {
        fileName = item.datas[j].logoName;
      } else {
        const {
          sizeName,
          size: { width, height },
        } = drawData;
        fileName = sizeName + " " + width + "x" + height;
      }
      imgMaps.push({
        name: fileName,
        data: base64Data,
      });
    }
  }
  return await batchDownLoadDesign(imgMaps, "AI");
};

// 批量下载处理函数
const batchDownLoadDesign = async (imgBase64Datas, type) => {
  // 如果只有一个文件，使用原来的下载方法
  if (imgBase64Datas.length <= 8) {
    return await downLoadDesign(imgBase64Datas, type);
  }
  // 多个文件时进行分批处理
  const BATCH_SIZE = 9;
  const tasks = [];
  // 将文件分组
  for (let i = 0; i < imgBase64Datas.length; i += BATCH_SIZE) {
    const batch = imgBase64Datas.slice(i, i + BATCH_SIZE);
    tasks.push(downLoadDesign(batch, type));
  }
  try {
    return Promise.all(tasks)
      .then(() => {
        return {
          code: 10000,
        };
      })
      .catch(error => {
        console.error("Download failed:", error);
      });
  } catch (error) {
    console.error("Download failed:", error);
    throw error;
  }
};

export const downloadBase64 = async (datas, name) => {
  // 绘制
  const imgMaps = [];
  for (let i = 0; i < datas.length; i++) {
    const banner = datas[i];
    let bannerDom = document.querySelector("#" + name + i);
    const bannerBase64Data = await htmlToCanvas(bannerDom, 2);
    const {
      sizeName,
      size: { width, height },
    } = banner;
    let fileName = sizeName + " " + width + "x" + height;
    if (name === "poster") {
      fileName = sizeName;
    }
    imgMaps.push({
      name: fileName,
      data: bannerBase64Data,
    });
  }
  return await downLoadDesign(imgMaps, name);
};
const downLoadDesign = async (imgBase64Datas, type) => {
  const formData = new FormData();
  imgBase64Datas.forEach((imgBase64Data, index) => {
    const name = `${imgBase64Data.name}-${index}`;
    formData.append(type, base64toFile(imgBase64Data.data, name));
  });
  // 图片压缩
  const res = await http.postDown(api.compress, formData);
  const data = res && res.data;
  const resorceName =
    imgBase64Datas.length > 1
      ? `${type}-images-compressed.zip`
      : `${imgBase64Datas[0].name}.png`;
  if (data && data.result) {
    saveAs(`//bar.xkw.com${data.result}`, resorceName);
    return data;
  }
  return { result: null, message: (res && res.message) || "图片压缩失败" };
};
const downImgmin = async res => {
  let resorceName = res.split("/")[res.split("/").length - 1];
  saveAs(`//bar.xkw.com${res}`, resorceName);
  store.commit("clearSizeCacheInfo");
};
const base64toFile = (data, filename) => {
  let arr = data.split(",");
  let mime = arr[0].match(/:(.*?);/)[1];
  let suffix = mime.split("/")[1];
  let bstr = atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], `${filename}.${suffix}`, {
    type: mime,
  });
};

const storage = window.sessionStorage;
export {
  base64toFile,
  downImgmin,
  downLoadDesign,
  hexToRGB,
  isArray,
  isObject,
  isPlainObj,
  makeMap,
  storage
};

